import React from "react";
import classes from "../Store.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import * as fa from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../../../components/Spinner";
import { useTranslation } from "react-i18next";
import Logo from "../../../../assets/images/logo192.png";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import RoundButton from "../../../../components/Buttons/RoundButton";

interface ProductSelectionCardProps {
  qntOfJourneys: number;
  productInfo: { price: number }[];
  permission: { audiofoco_journey: number };
  setQntOfJourneys: (value: number) => void;
  setProductChoosed: (value: number) => void;
  stage: number;
  setStage: (value: number) => void;
}

const ProductSelectionCard: React.FC<ProductSelectionCardProps> = ({
  qntOfJourneys,
  productInfo,
  permission,
  setQntOfJourneys,
  setProductChoosed,
  stage,
  setStage,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes.DetailsCard}>
      <h2>{t("global.order_details")}</h2>

      <div className={classes.ProductInfo}>
        <div className={classes.ProductInfoDetails}>
          <img src={Logo} alt="Jornada Smart" />
          <div>
            <div>{t("global.you_are_purchasing")}:</div>
            <p>{t("global.smart_journey")}</p>
          </div>
        </div>

        {productInfo ? (
          <div className={classes.ProductInfoDetailsPrice}>
            <p>
              R$:{" "}
              {qntOfJourneys === 0
                ? "0,00"
                : qntOfJourneys === permission?.audiofoco_journey
                  ? String(productInfo[0]?.price / 5).replace(".", ",") + "0"
                  : String(productInfo[1]?.price / 10).replace(".", ",") + "0"}
            </p>

            <div className={classes.ProductInfoDetailsByJourneyInfo}>
              {t("global.per_journey")}
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>

      <div className={classes.InfosDetailsCard}>
        <p>{t("global.enter_quantity")}</p>
        <p>{t("global.enter_quantity_info")}</p>
      </div>

      <Select
        className={classes.InputArea}
        defaultValue={0}
        onChange={(e) => {
          const value = Number(e.target.value);

          setQntOfJourneys(value);
          setProductChoosed(value === 5 ? 0 : 1);
        }}
      >
        <MenuItem value={0}>Selecione a quantidade</MenuItem>
        <MenuItem value={5}>5</MenuItem>
        <MenuItem value={10}>10</MenuItem>
      </Select>

      <div className={classes.CalculateButtonContainer}>
        <RoundButton
          onClick={() => setStage(stage === 3 ? 1 : stage + 1)}
          text={t("global.continue_to_payment")}
          title={t("global.continue_to_payment")}
          disabled={qntOfJourneys <= 0}
          faIcon={faArrowRight}
        />
      </div>

      <div className={classes.MoreInfo}>
        <FontAwesomeIcon icon={fa.faCircleExclamation} />
        {t("global.more_than_10_journeys")}{" "}
        {t("global.request_a_quote_with_us")}
      </div>
    </div>
  );
};

export default ProductSelectionCard;
